import { render, staticRenderFns } from "./MembershipsLapsed.vue?vue&type=template&id=5f5d97b3&scoped=true"
import script from "./MembershipsLapsed.vue?vue&type=script&lang=ts"
export * from "./MembershipsLapsed.vue?vue&type=script&lang=ts"
import style0 from "./MembershipsLapsed.vue?vue&type=style&index=0&id=5f5d97b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d97b3",
  null
  
)

export default component.exports